const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Old CRM links carried the organization as the first URL segment (`/<organizationId>/clients/...`,
 * GSB-7332). CRM has none now (GSB-8472, PO 2026-10-29): returns the path without it, or `undefined`
 * when the first segment is not a GUID.
 */
export const stripLegacyOrganization = (pathname: string) => {
  const [, firstSegment, ...rest] = pathname.split('/');

  if (!firstSegment || !GUID_PATTERN.test(firstSegment)) return undefined;

  return `/${rest.join('/')}`;
};

/** Replaces an old `/<organizationId>/rest` address with `/rest`, keeping the query and the hash. */
export const redirectLegacyOrganizationPath = (
  location: Pick<Location, 'pathname' | 'search' | 'hash'>,
  history: Pick<History, 'replaceState'>,
) => {
  const path = stripLegacyOrganization(location.pathname);

  if (path === undefined) return;

  history.replaceState(null, '', `${path}${location.search}${location.hash}`);
};
